export default __webpack_public_path__ + "static/TX2-68aba764caed779d347d6f16444bbdd8.svg";